<template>
  <div class="Calories">
    <div class="back" @click="$router.go(-1)">
      <i class="el-icon-back"></i> <span>返回上一页</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="热量" name="first">
        <el-table :data="tableData" :border="true">
          <el-table-column label="序号" width="80" align="center" type="index">
          </el-table-column>
          <el-table-column label="测量时间" align="center" prop="Day">
            <template slot-scope="scope" align="center">
              {{ scope.row.Day | handtime | handDay }}
            </template>
          </el-table-column>
          <el-table-column
            label="设备型号"
            align="center"
            prop="daDeviceType"
          >
            <template slot-scope="scope" align="center">
              {{ scope.row.DeviceType || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="总热量" align="center" prop="TotalHeat">
            <template slot-scope="scope" align="center">
              {{ scope.row.TotalHeat || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="行走量" align="center" prop="Walk">
            <template slot-scope="scope" align="center">
              {{ scope.row.Walk || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="运动量" align="center" prop="Sport">
            <template slot-scope="scope" align="center">
              {{ scope.row.Sport || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="基础消耗" align="center" prop="Base">
            <template slot-scope="scope" align="center">
              {{ scope.row.Base || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          :current-page="page"
          @current-change="changefn"
          :page-size="size"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { requestUserHeatData } from "@/api/userApi";
import { handtime } from "@/utils/util";
export default {
  name: "Calories",
  data() {
    return {
      activeName: "first",
      page: 1,
      size: 10,
      total: 0,
      tableData: [
        {
          date: 111,
        },
      ],
    };
  },
  created() {
    this.requestUserHeatDatafn();
  },
  methods: {
    changefn(index){
      this.page =index;
      this.requestUserHeatDatafn();


    },
    async requestUserHeatDatafn() {
      var res = await requestUserHeatData({
        userId: this.$route.query.id,
        page: this.page,
        size: this.size,
      });
      this.tableData = res.data.data.result.list;
      this.total = res.data.data.result.count;
    },
  },
  filters: {
    handtime,
    handDay(time){
      if(time=="-"){
        return "-"
      }else{
        return time.slice(0,10)
      }

    }
  },
};
</script>

<style lang="less">
.Calories {
  padding: 15px;
  position: relative;
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>